import { Skeleton } from "@mui/material";
import SortedItemsList, {
  ItemListElement,
} from "../../../../components/SortedItemsList/SortedItemsList";
import defaultAvatar from "../../../../img/defaultProfile.jpg";
import { useEffect, useState } from "react";
import { TopUser } from "../../../../types/authTypes";
import { COLLECTION_TAB } from "../../../MyProfile/MyProfile";
import { COLLECTION_SECTION } from "../../../MyProfile/Collection/Collection";

interface TopCollectionsQtyProps {
  users: Array<TopUser>;
  pathAll: string;
}

const TopCollectionsQty = ({ users, pathAll }: TopCollectionsQtyProps) => {
  const title = "Biggest collections";

  const [list, setList] = useState<Array<ItemListElement> | undefined>(
    undefined,
  );
  const [userId, setUserId] = useState<number | undefined>(undefined);

  useEffect(() => {
    setList(
      users
        .map((user) => {
          return {
            id: user.id,
            name: user.username,
            value: user.item_count ? user.item_count : 0,
            profile_image: user.profile_image?.url,
          };
        })
        .sort((a, b) => b.value - a.value),
    );
  }, [users]);

  useEffect(() => {}, [userId]);

  const renderValue = (value: number) => {
    return "Number of shirts: " + String(value);
  };

  const goCollection = (userId: number) => {
    // TODO: change for proper react redirect
    document.location =
      "/my-profile/" +
      userId +
      "/" +
      COLLECTION_TAB.COLLECTION +
      "/" +
      COLLECTION_SECTION.OVERVIEW;
  };

  return list ? (
    <SortedItemsList
      list={list}
      title={title}
      renderValue={renderValue}
      defaultAvatarImg={defaultAvatar}
      fullListUrl={pathAll}
      onClick={goCollection}
      maxItems={5}
    />
  ) : (
    <Skeleton variant="rectangular" width={210} height={30} />
  );
};

export default TopCollectionsQty;
